(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedcustomerfeedbackcarouselblock = window.oneadvanced.refreshedcustomerfeedbackcarouselblock || {};
    window.oneadvanced.refreshedcustomerfeedbackcarouselblock.init = function () {
        //console.log("initializing refreshedcustomerfeedbackcarouselblock js.......");

        //This function is used to add the swipper for refreshedcustomerfeedbackcarouselblock
        function cfcHandler(BlockId) {
            // store the previous and next arrows html elements
            const prevButton = document.getElementById('swiperPrev_' + BlockId);
            const nextButton = document.getElementById('swiperNext_' + BlockId);

            // initialise unique blockID swiper
            const swiper = new Swiper('[data-stories-block-id="' + BlockId + '"]', {
                direction: 'horizontal',
                slidesPerView: 'auto',
                initialSlide: 0,
                loop: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
            });

            // Checks where the carousel is at (start, middle or end) and toggles visibility class for prev,next arrows
            toggleButtons = function (prevButton, nextButton, swiper) {
                if (swiper.isBeginning) {
                    if (!prevButton.classList.contains('invisible')) {
                        prevButton.classList.add('invisible');
                    }
                    if (nextButton.classList.contains('invisible')) {
                        nextButton.classList.remove('invisible');
                    }
                } else if (swiper.isEnd) {
                    if (prevButton.classList.contains('invisible')) {
                        prevButton.classList.remove('invisible');
                    }
                    if (!nextButton.classList.contains('invisible')) {
                        nextButton.classList.add('invisible');
                    }
                } else {
                    if (prevButton.classList.contains('invisible')) {
                        prevButton.classList.remove('invisible');
                    }
                    if (nextButton.classList.contains('invisible')) {
                        nextButton.classList.remove('invisible');
                    }
                }
            }

            // This code below handles the cases when we have more than 1 carosuel with Swiper on the page.
            // Otherwise, pressing one Swiper's next/prev button affects all swipers slides.
            // Define separate event handlers for each swiper instance.
            function createSlideNextHandler(swiper) {
                return function (e) {
                    swiper.slideNext();
                    toggleButtons(prevButton, nextButton, swiper);
                };
            }

            function createSlidePrevHandler(swiper) {
                return function (e) {
                    swiper.slidePrev();
                    toggleButtons(prevButton, nextButton, swiper);
                };
            }

            // Attach event handlers to the next prev buttons.
            const slideNextButton = document.getElementById('swiperNext_' + BlockId);
            slideNextButton.addEventListener('click', createSlideNextHandler(swiper));

            const slidePrevButton = document.getElementById('swiperPrev_' + BlockId);
            slidePrevButton.addEventListener('click', createSlidePrevHandler(swiper));
        }


        //Below code is to call the cfcHandler function defined above
        var customerfeedbackcarouselblock = document.querySelectorAll('[data-stories-block-id]');

        if (customerfeedbackcarouselblock.length) {
            for (var cfc = 0; cfc < customerfeedbackcarouselblock.length; cfc++) {
                cfcHandler(
                    customerfeedbackcarouselblock[cfc].getAttribute('data-stories-block-id')
                );
            }
        }

        //Below Code is used to add swiper-slide class to the carousel for the larger screens other than mobile view
        var swiper_wraper_content = document.querySelectorAll('.refreshedcustomerfeedbackcarouselblock .swiper-wrapper');

        for (var i = 0; i < swiper_wraper_content.length; i++) {
            for (var e = 0; e < swiper_wraper_content[i].children.length; e++) {
                swiper_wraper_content[i].children[e].classList.add("swiper-slide");
            }
        }

        //Below Code is used to add swipe-slide class to the carousel only for mobile view
        var swiper_container_content = document.querySelectorAll('.refreshedcustomerfeedbackcarouselblock .swipe-container');

        for (var i = 0; i < swiper_container_content.length; i++) {
            for (var e = 0; e < swiper_container_content[i].children.length; e++) {
                swiper_container_content[i].children[e].classList.add("swipe-slide");
            }
        }
    };

    window.oneadvanced.refreshedcustomerfeedbackcarouselblock.hasLoaded = true;
})();